var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, svg } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ThemedDeviceIcon, deviceIconStyles } from './device-icon-base';
/*
 * <vitesse-cnc-icon> — the CNC-lathe glyph, sibling to <vitesse-plc-icon> from
 * the same Vitesse "PLC & CNC Icon Set" asset. Landscape 300×210.
 *
 * Live status via `state` (idle | running | error | offline):
 *   running → stack-light green breathes, spindle chuck spins, RDY display glows
 *   error   → stack-light red pulses + amber warns
 *   offline → display dims
 * Theme + sizing behave exactly like <vitesse-plc-icon>. Not wired into any view
 * yet — it's here for when CNC controllers land.
 *
 *   <vitesse-cnc-icon state="running" width="72" height="50"></vitesse-cnc-icon>
 */
let VitesseCncIcon = class VitesseCncIcon extends ThemedDeviceIcon {
    constructor() {
        super(...arguments);
        this.markup = svg `
    <path d="M248 8a9 6 0 0 1 18 0z" style="fill:var(--bezel)"/>
    <rect x="248" y="8" width="18" height="9" rx="2" class="led led--twr-r"/>
    <rect x="246.5" y="16" width="21" height="2" style="fill:var(--bezel)"/>
    <rect x="248" y="18" width="18" height="9" rx="2" class="led led--twr-a"/>
    <rect x="246.5" y="26" width="21" height="2" style="fill:var(--bezel)"/>
    <rect x="248" y="28" width="18" height="9" rx="2" class="led led--twr-g"/>
    <rect x="253" y="37" width="8" height="8" style="fill:var(--bezel)"/>
    <rect x="10" y="40" width="280" height="150" rx="15" style="fill:var(--bezel)"/>
    <rect x="18" y="48" width="264" height="134" rx="9" style="fill:var(--body)"/>
    <rect x="28" y="60" width="196" height="112" rx="8" style="fill:var(--display-bg)"/>
    <rect x="36" y="86" width="30" height="60" rx="3" style="fill:var(--plate)"/>
    <g class="spin">
      <circle cx="72" cy="116" r="18" style="fill:var(--screw)"/>
      <circle cx="72" cy="116" r="8" style="fill:var(--body)"/>
      <rect x="69" y="99" width="6" height="8" rx="1.5" style="fill:var(--body)"/>
      <rect x="69" y="125" width="6" height="8" rx="1.5" style="fill:var(--body)"/>
      <rect x="55" y="113" width="8" height="6" rx="1.5" style="fill:var(--body)"/>
      <rect x="81" y="113" width="8" height="6" rx="1.5" style="fill:var(--body)"/>
    </g>
    <rect x="90" y="110" width="86" height="12" rx="2" style="fill:var(--port-pin, var(--plate))"/>
    <rect x="182" y="98" width="26" height="36" rx="3" style="fill:var(--plate)"/>
    <polygon points="176,116 182,110 182,122" style="fill:var(--screw)"/>
    <rect x="120" y="132" width="22" height="24" rx="2" style="fill:var(--plate)"/>
    <polygon points="131,126 126,132 136,132" style="fill:var(--screw)"/>
    <rect x="30" y="160" width="192" height="8" rx="2" style="fill:var(--plate)"/>
    <polygon points="28,60 58,60 34,108 28,94" style="fill:#fff;opacity:.05"/>
    <rect x="232" y="60" width="50" height="112" rx="7" style="fill:var(--plate)"/>
    <rect x="238" y="68" width="38" height="28" rx="3" style="fill:var(--display-bg)"/>
    <text class="disp-glow" x="257" y="86" text-anchor="middle" style="font:600 10px 'IBM Plex Mono',monospace;fill:var(--display-tx)">RDY</text>
    <circle cx="246" cy="112" r="4.5" style="fill:var(--body)"/>
    <circle cx="268" cy="112" r="4.5" style="fill:var(--body)"/>
    <circle cx="257" cy="146" r="12" style="fill:var(--red)"/>
    <circle cx="257" cy="146" r="7" style="fill:#a01818"/>
    <rect x="36" y="190" width="22" height="11" rx="3" style="fill:var(--bezel)"/>
    <rect x="240" y="190" width="22" height="11" rx="3" style="fill:var(--bezel)"/>
  `;
    }
    static { this.styles = deviceIconStyles; }
    render() {
        const w = this.width || 72;
        const h = this.height || 50;
        return html `<svg
      width=${w}
      height=${h}
      viewBox="0 0 300 210"
      role="img"
      aria-label="CNC lathe"
      data-state=${this.state}
      part="svg"
    >
      ${this.markup}
    </svg>`;
    }
};
VitesseCncIcon = __decorate([
    customElement('vitesse-cnc-icon')
], VitesseCncIcon);
export { VitesseCncIcon };
//# sourceMappingURL=vitesse-cnc-icon.js.map